import { Controller } from 'stimulus';

const ERROR_CLASS = 'field--error';

export default class extends Controller {
  static values = { limit: Number };

  #over = false;

  apply({ detail: { current, total } }) {
    const limit = this.hasLimitValue ? this.limitValue : total;
    const over = Number.isFinite(limit) && current > limit;
    const counter = this.element.querySelector('[data-ui--counter-target="counter"]');
    const field = this.element.querySelector('input, textarea');

    counter?.classList.toggle('text-df-danger', over);
    counter?.classList.toggle('text-gray-500', !over);

    if (over) {
      field?.classList.add(ERROR_CLASS);
    } else if (this.#over) {
      field?.classList.remove(ERROR_CLASS);
    }

    if (over !== this.#over) {
      this.#over = over;
      this.dispatch(over ? 'invalid' : 'valid');
    }
  }
}
